import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts'

interface ChartProps {
  className?: string
  data?: Array<{ name: string; value: number; color: string }>
}

// Simple placeholder charts for now - these would be replaced with actual chart library components
export function VolumeChart({ className }: ChartProps) {
  return (
    <div
      className={`h-64 bg-muted/20 rounded-lg border border-dashed border-muted-foreground/25 flex items-center justify-center ${className}`}
    >
      <div className="text-center text-muted-foreground">
        <div className="text-lg font-medium mb-2">Volume Chart</div>
        <div className="text-sm">Berichten volume over tijd</div>
      </div>
    </div>
  )
}

export function TopicsChart({ className }: ChartProps) {
  return (
    <div
      className={`h-64 bg-muted/20 rounded-lg border border-dashed border-muted-foreground/25 flex items-center justify-center ${className}`}
    >
      <div className="text-center text-muted-foreground">
        <div className="text-lg font-medium mb-2">Topics Chart</div>
        <div className="text-sm">Onderwerpen op frequentie</div>
      </div>
    </div>
  )
}

export function SentimentChart({ className, data }: ChartProps) {
  if (!data || data.length === 0) {
    return (
      <div
        className={`h-64 bg-muted/20 rounded-lg border border-dashed border-muted-foreground/25 flex items-center justify-center ${className}`}
      >
        <div className="text-center text-muted-foreground">
          <div className="text-lg font-medium mb-2">Sentiment Chart</div>
          <div className="text-sm">Geen sentiment data beschikbaar</div>
        </div>
      </div>
    )
  }

  return (
    <div className={`h-64 ${className}`}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie data={data} cx="50%" cy="50%" outerRadius={80} fill="#8884d8" dataKey="value">
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

export function TagCloudChart({ className }: ChartProps) {
  return (
    <div
      className={`h-64 bg-muted/20 rounded-lg border border-dashed border-muted-foreground/25 flex items-center justify-center ${className}`}
    >
      <div className="text-center text-muted-foreground">
        <div className="text-lg font-medium mb-2">Tag Cloud</div>
        <div className="text-sm">Onderwerpen cloud</div>
      </div>
    </div>
  )
}
